import { render, staticRenderFns } from "./new-thread.vue?vue&type=template&id=3ad8cb89&scoped=true"
import script from "./new-thread.vue?vue&type=script&lang=js"
export * from "./new-thread.vue?vue&type=script&lang=js"
import style0 from "./new-thread.vue?vue&type=style&index=0&id=3ad8cb89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8cb89",
  null
  
)

export default component.exports